import { Skeleton } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { WalletId, getWalletInfo } from 'thirdweb/wallets'
import { socialsMethods } from './socialsMethods'
import { mipdStore } from '@/services/wallet-service'
import EmailIcon from '@/public/assets/images/sign-in/at.png'
import Image from 'next/image'

export const WalletImage = ({
  id,
  width = 40,
  height = 40,
}: {
  id: string | null
  width?: number
  height?: number
}) => {
  const { data, isLoading } = useQuery({
    queryKey: ['WALLET_IMAGE', id],
    queryFn: async () => {
      if (id!.startsWith('social')) {
        return socialsMethods.find((method) => method.strategy === id!.split('-').at(1))?.icon
      }

      if (id === 'email') {
        return EmailIcon
      }

      const providerIcon = mipdStore.findProvider({ rdns: id! as WalletId })?.info.icon.trim()

      if (!!providerIcon) {
        return providerIcon
      }

      return await getWalletInfo(id! as WalletId, true)
    },
    enabled: !!id,
  })

  if (isLoading || !data) {
    return <Skeleton h={10} w={10} startColor={'ninja.700'} endColor={'ninja.800'} rounded={'xl'} />
  }

  if (!id) {
    return null
  }

  return <Image style={{ borderRadius: '12px' }} width={width} height={height} alt={''} src={data} />
}
